import styled from "styled-components";

export const CollabToggleText = styled("span")`
  color: #3d414a;
  font-size: 12px;
  margin-right: 0.5rem;
  font-weight: bold;
`;

export const BackLink = styled("a")`
  display: flex;
  align-items: center;
  color: black;
  text-decoration: underline;
  max-width: 120px;
  > svg {
    margin-right: 6px;
  }
  &:hover {
    text-decoration: inherit;
    color: inherit;
  }
`;
